import { Injectable, signal } from '@angular/core';

@Injectable()
export class SalesPriceQueryService {
  showAll = signal(false);
}
